import React, { useState } from "react";
import {
  Button,
  Dialog,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  DialogContent,
  DialogActions,
  TextField,
  Grid,
  MenuItem,
  Stack,
  Box,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import GlobalButton from "../../common/GlobalButton";
import SaveIcon from "@mui/icons-material/Save";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import BackWithArrow from "../../common/BackWithArrow";
import PluseIconDesign from "../../common/PluseIconDesign";

const departments = ["Production", "Quality", "Logistics"];
const ideaTypes = ["Kaizen", "Suggestion", "Audit Finding"];
const impacts = ["High", "Medium", "Low"];

export default function AddIdeaButton() {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({
    title: "",
    department: "",
    ideaType: "",
    impact: "",
    description: "",
  });

  const handleChange = (field) => (e) =>
    setForm({ ...form, [field]: e.target.value });

  const handleSubmit = () => {
    alert("Idea Submitted:\n" + JSON.stringify(form, null, 2));
    setOpen(false);
    setClose(closed);
    setForm({
      title: "",
      department: "",
      ideaType: "",
      impact: "",
      description: "",
    });
  };

  return (
    <>
      <PluseIconDesign onClick={() => setOpen(true)} />
      <Dialog
        fullScreen
        PaperProps={{
          sx: {
            minHeight: "100vh",
            maxHeight: "100vh",
            background: "white",
          },
        }}
        open={open}
      >
        <BackWithArrow onBack={() => setOpen(false)} />

        <DialogContent sx={{ p: 4 }}>
          <Typography variant="h5" gutterBottom>
            Submit a Continuous Improvement Idea
          </Typography>

          <Grid container spacing={3} sx={{ mt: 1 }}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                required
                label="Idea Title"
                value={form.title}
                onChange={handleChange("title")}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                select
                fullWidth
                required
                label="Department"
                value={form.department}
                onChange={handleChange("department")}
              >
                {departments.map((dep) => (
                  <MenuItem key={dep} value={dep}>
                    {dep}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                select
                fullWidth
                label="Idea Type"
                value={form.ideaType}
                onChange={handleChange("ideaType")}
              >
                {ideaTypes.map((type) => (
                  <MenuItem key={type} value={type}>
                    {type}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                select
                fullWidth
                label="Impact Level"
                value={form.impact}
                onChange={handleChange("impact")}
              >
                {impacts.map((level) => (
                  <MenuItem key={level} value={level}>
                    {level}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>

            <Grid item xs={12}>
              <TextField
                multiline
                rows={4}
                fullWidth
                label="Description"
                value={form.description}
                onChange={handleChange("description")}
              />
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions sx={{ justifyContent: "center", p: 3 }}>
          <Stack direction="row" spacing={2}>
            <GlobalButton
              icon={<RestartAltIcon />}
              variant="outlined"
              onClick={() => setOpen(false)}
            >
              Reset
            </GlobalButton>
            <GlobalButton
              icon={<SaveIcon />}
              onClick={handleSubmit}
              size="large"
            >
              Save
            </GlobalButton>
          </Stack>
        </DialogActions>
      </Dialog>
    </>
  );
}
